import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {INav} from '../navigation/navigation.component';
import {environment} from '../../../environments/environment';
import {Observable} from "rxjs";
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
    faBox,
    faCog,
    faLock,
    faLockOpen,
    faTruck,
    faUser,
    faUserFriends,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import {Router} from "@angular/router";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    private authedPermissions: Observable<any[]>;

    public headerClass = '';

    constructor(public authService: AuthService, public router: Router) {
        this.authedPermissions = this.authService.authedPermissionsDataStream();
    }

    menuData: INav[] = null;

    ngOnInit(): void {
        this.authedPermissions.subscribe(() => {
            this.setupMenus();
        });

        this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
            this.headerClass = this.getHeaderClass(event.urlAfterRedirects);
        });
    }

    private getHeaderClass(url: string): string {
        if (url === '/custom/salgsordre' || /^\/orders\/[0-9a-f-]+\/\(order_outlet:order-(details|overview|delivery)\)$/i.test(url)) {
            return 'gradient-sale';
        }

        if (url === '/custom/koebsordre') {
            return 'gradient-buy';
        }

        if (url === '/custom/opslag') {
            return 'gradient-lookup';
        }

        if (url === '/custom/kartotek' || url === '/debtors' || /^\/debtors\/[0-9a-f-]+$/i.test(url)) {
            return 'gradient-inventory';
        }

        if (url === '/custom/udskrifter') {
            return 'gradient-print';
        }

        if (url === '/custom/finans') {
            return 'gradient-finance';
        }

        if (url === '/custom/koncern') {
            return 'gradient-corporate';
        }

        return '';
    }

    setupMenus(): void {
        // @todo make this cleaner and more extensible
        // @todo implement stateservice and listen for state changes
        switch (environment.customer) {
            case '10-4':
                this.setTenFourMenu();
                break;
            case 'helms' :
                this.setHelmsMenu();
                break;
            default:
                this.setDefaultMenu();
                break;
        }
    }

    setDefaultMenu(): void {
        this.menuData = [
            {
                title: $localize`Orders`,
                url: '/orders',
                className: 'navigation__item--orders',
                permission: 'loggedIn',
                icon: faTruck
            },
            {
                title: $localize`Creditors`,
                url: '/creditors',
                className: 'navigation__item--creditors',
                permission: 'loggedIn',
                icon: faUsers
            },
            {
                title: $localize `Debtors`,
                url: '/debtors',
                className: 'navigation__item--debtors',
                permission: 'loggedIn',
                icon: faUserFriends
            },
            {
                title: $localize `Products`,
                url: '/products',
                className: 'navigation__item--products',
                permission: 'loggedIn',
                icon: faBox
            },
            {
                title: $localize `Articles`,
                url: '/articles',
                className: 'navigation__item--articles',
                permission: 'loggedIn',
                icon: faBox
            },
            {
                title: $localize  `Settings`,
                url: '/settings',
                permission: 'admin',
                className: 'navigation__item--settings',
                icon: faCog
            },
            {
                title: this.authService.loggedIn() ? $localize `Logout` : $localize `Login`,
                url: !this.authService.loggedIn() ? '/login' : undefined,
                onClick: this.authService.loggedIn() ? () => this.authService.logout() : undefined,
                className: this.authService.loggedIn() ? 'navigation__item--logout' : 'navigation__item--login',
                icon: this.authService.loggedIn() ? faLock : faLockOpen,
            },
        ];
    }

    setTenFourMenu(): void {
        this.menuData = [
            {
                title: 'Salgsordre', // idaweben
                url: 'custom/salgsordre',
                permission: 'admin,debtors',
            },
            {
                title: 'Købsordre', // kobweben
                url: 'custom/koebsordre',
                permission: 'admin, debtors'
            },
            {
                title: 'Opslag', // idaintra
                url: 'custom/opslag',
                permission: 'admin,debtors',
            },
            {
                title: 'Kartotek', // karweben
                url: 'custom/kartotek',
                permission: 'admin, debtors',
            },
            {
                title: 'Udskrifter', // skrweben
                url: 'custom/udskrifter',
                permission: 'admin, debtors',
            },
            {
                title: 'Finans', // finweben
                url: 'custom/finans',
                permission: 'admin, debtors',
            },
            {
                title: 'Koncern', // konweben
                url: 'custom/koncern',
                permission: 'admin, debtors',
            },
            {
                title: $localize `Settings`,
                url: '/settings',
                permission: 'admin',
                icon: faCog,
            },
            {
                title: this.authService.loggedIn() ? 'Log ud' : 'Log ind',
                url: !this.authService.loggedIn() ? '/login' : undefined,
                onClick: this.authService.loggedIn() ? () => this.authService.logout() : undefined,
                icon: this.authService.loggedIn() ? faLock : faLockOpen,
            },
        ];
    }

    setHelmsMenu(): void {
        this.menuData = [
            {
                title: $localize `Create order`,
                url: '/offers',
                permission: 'admin,debtors',
                children: [
                    {
                        title: $localize`Create order`,
                        url: '/offers',
                        permission: 'admin, debtors'
                    },
                    {
                        title: $localize`Tool order`,
                        url: '/tool-offers',
                        permission: 'admin, debtors'
                    },{
                        title: $localize `Stock list`,
                        url: '/custom/inventory',
                        permission: 'admin, debtors'
                    },
                ]
            },
            {
                title: $localize `My orders`,
                url: '/custom/my-orders',
                permission: 'debtors',
            },
            {
                title: $localize`My offers`,
                url: '/custom/offers',
                permission: 'debtors',
            },
            {
                title: $localize `Orders`,
                url: '/orders',
                permission: 'admin,branch_admin',
            },
            //  {
            //      title: 'Lager',
            //      url: '/shipment',
            //      className: 'navigation__item--shipment',
            //  },
            //  {
            //      title: 'Diverse',
            //      url: '/shipment',
            //      className: 'navigation__item--shipment',
            //  },

            {
                title: 'Diverse',
                children: [
                    // {
                    //     title: 'Lager',
                    //     url: '/custom/inventory',
                    //     permission: 'admin',
                    // },
                    {
                        title: $localize `On way`,
                        url: '/custom/arrivals',
                        permission: 'admin'
                    },
                    {
                        title: $localize `Factory`,
                        url: '/custom/factory',
                        permission: 'admin'
                    },
                    {
                        title: $localize`Compare`,
                        url: '/custom/compare',
                        permission: 'admin, debtors'
                    },
                    {
                        title: $localize`Production lines`,
                        url: '/production-lines',
                        permission: 'admin, debtors',
                    },
                    {
                        title: 'Demo Bestilling',
                        url: '/custom/demos',
                        permission: 'admin, debtors',
                    },
                    {
                        title: $localize`File center`,
                        url: '/custom/file-center',
                        permission: 'admin, debtors',
                    },
                    {
                        title: $localize`Sales statistics`,
                        url: '/custom/statistics',
                        permission: 'admin, creditors',
                    }
                ]
            },
            {
                title: $localize`Settings`,
                url: '/settings',
                permission: 'admin',
                icon: faCog,
                children: [
                    {
                        title: $localize`Settings`,
                        url: '/settings',
                        permission: 'admin',
                        icon: faCog,
                    },
                    {
                        title: 'Forhandlere',
                        url: '/debtors',
                        permission: 'admin',
                    },
                ]
            },
            {
                title: this.authService.loggedIn() ? $localize`log out` : $localize`log ind`,
                url: !this.authService.loggedIn() ? '/login' : undefined,
                onClick: this.authService.loggedIn() ? () => this.authService.logout() : undefined,
                icon: this.authService.loggedIn() ? faLock : faLockOpen,
            },
        ];
    }


    headerLogo(): string {

        if (environment.customer === 'helms') {
            return '<img src="../../../assets/themes/helms/assets/png/schaffer-logo.png" class="header__logo-img  img-responsive" />';
        } else {
            return '<img src="../../../assets/themes/10-4/images/logo.svg" class="header__logo-img  img-responsive" />';
        }

    }
}
